import React, { forwardRef } from 'react';

type ClickableDivCallback = (e: React.MouseEvent<HTMLDivElement>) => void | null;

interface ClickableDivProps {
  disabled?: boolean;
  id?: string;
  onClick: ClickableDivCallback;
  className?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  tabIndex?: number;
}

const ClickableDiv = forwardRef<HTMLDivElement, ClickableDivProps>((props, ref) => {
  return (
    <div
      id={props.id}
      ref={ref}
      className={props.className ?? '' + ' pointer'}
      onClick={props.disabled ? (e) => e.stopPropagation() : props.onClick}
      style={props.style}
      role="button"
      tabIndex={props.tabIndex ?? 0}
    >
      {props.children}
    </div>
  );
});

export default ClickableDiv;
